var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c(_vm.currentView,{tag:"component",attrs:{"currentView":_vm.currentView},on:{"update:currentView":function($event){_vm.currentView=$event},"update:current-view":function($event){_vm.currentView=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }